import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CallbackComponent, UnauthorizedComponent } from '@privatelib/ngx18-authz-dev';

import { LoginComponent } from './components/auth/login/login.component';
import { TwoStepVerificationComponent } from './components/auth/two-step-verification/two-step-verification.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SoapConfigurationComponent } from './components/soap-configuration/soap-configuration.component';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password.component';
import { AppointmentListComponent } from "./components/appointment-list/appointment-list.component";
import { PatientDashboardComponent } from "./components/patient-dashboard/patient-dashboard.component";

import { AuthGuard } from './services/guards/auth.guard';
import { ROUTE_CONSTANTS } from './util/route.constants';
import { ChangePasswordComponent } from './components/auth/change-password/change-password.component';
import { PermissionGuard } from './services/guards/permissionGuard';
import { ConsultationComponent } from "./components/consultation/consultation.component";
import { LicComponent } from './components/lic/lic.component';
import { FacilitySelectionComponent } from './components/facility-selection/facility-selection.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { PracticeSignupComponent } from './components/practice-signup/practice-signup.component';
import { LicLogoffScreenComponent } from './components/lic-logoff-screen/lic-logoff-screen.component';


const routes: Routes = [
  {
    path: ROUTE_CONSTANTS.LOGIN,
    component: LoginComponent
  },
  {
    path: ROUTE_CONSTANTS.TWO_STEP_VERIFICATION,
    component: TwoStepVerificationComponent
  },
  {
    path: 'auth/unauthorized',
    component: UnauthorizedComponent
  },
  {
    path: 'auth/callback',
    component: CallbackComponent
  },
  {
    path: ROUTE_CONSTANTS.CHANGE_PASSWORD,
    component: ChangePasswordComponent,
    canActivate: [AuthGuard]
  },
  {
    path: ROUTE_CONSTANTS.RESET_PASSWORD,
    component: ResetPasswordComponent,
  },
  {
    path: ROUTE_CONSTANTS.DASHBOARD,
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ROUTE_CONSTANTS.APPOINTMENT,
    component: AppointmentListComponent,
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: ROUTE_CONSTANTS.PATIENT_DASHBOARD,
    component: PatientDashboardComponent,
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: ROUTE_CONSTANTS.CONSULTATION,
    component: ConsultationComponent,
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: ROUTE_CONSTANTS.SOAP_CONFIGURATION,
    component: SoapConfigurationComponent,
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: ROUTE_CONSTANTS.MANAGE_TEMPLATES, canActivate: [AuthGuard, PermissionGuard],
    loadChildren: () => import('./components/manage-template/manage-template.module').then(m => m.ManageTemplateModule)
  },
  {
    path: ROUTE_CONSTANTS.FORGOT_PASSWORD,
    component: ForgotPasswordComponent,
  },
  {
    path: ROUTE_CONSTANTS.LIC,
    component: LicComponent,
  },
  {
    path: ROUTE_CONSTANTS.FACILITY_SELECTION,
    component: FacilitySelectionComponent
  },
  {
    path: ROUTE_CONSTANTS.PRACTICE_SIGNUP,
    component: PracticeSignupComponent
  },
  {
    path: ROUTE_CONSTANTS.LIC_SESSION_EXPIRED,
    component: LicLogoffScreenComponent
  },
  {
    path: '',
    redirectTo: ROUTE_CONSTANTS.LIC,
    pathMatch: 'full',
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
